import { Component, OnInit ,ViewChild} from '@angular/core';
import { SharedModule } from "../../shared/shared.module";
import { AdminsService } from 'src/app/_services/admins/admins.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-ExtendBooking',
  templateUrl: './ExtendBooking.component.html',
  styleUrls: ['./ExtendBooking.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class ExtendBookingComponent implements OnInit {
  showSide: string;
  searchText: string='';
  extensions: never[];
  numberextension: number;
  subscriptions: Subscription[] = [];

  totalRecords: any;
  totalofPages: any;
  pageNumber= 1;
  pagesize= 10;
  first: number=1;
  rows: number=10;
Extend_ID:any;
  Extend_Approval:boolean=true;
  Extend_Approval_String:any;
  Extend_Reject_Reason:any;
  displayDialog: any;

  constructor(public _adminservices:AdminsService ,public router: Router    , private messageService: MessageService,private confirmationService: ConfirmationService
  ) { }
/////////////////////////////////////////////////
  globalFilter: string = '';

  currentPage: number = 0;
 @ViewChild('dt2', { static: false }) dt2?: any;
  tableReady = false;

  onPageChange(event: any) {
    this.currentPage = event.first;
    console.log(this.currentPage)
    localStorage.setItem('extenPage', this.currentPage.toString());
  }


  ngOnInit() {
    const savedPage = localStorage.getItem('extenPage');
    this.currentPage = savedPage ? +savedPage : 0;
    console.log(this.currentPage)
    /////////////////////////////////////////
    this.GetAllExtensionBookings()
  }


  searchTextChange:any
  searchAction(event: KeyboardEvent) {
    if (this.searchText.trim() === '' && (event.key === 'Backspace' || event.key === ' ')) {
      event.preventDefault();
      return;
  }
    this.GetAllExtensionBookings()

  }
ShowApproval_Dialog:boolean;
Show_Reject_Reason_Input:boolean;
ShowApproval(extend_ID:any){
  this.ShowApproval_Dialog=true;
  this.Extend_ID=extend_ID;
}
hideApproval(){
  this.ShowApproval_Dialog=false;
}

Reject_Input(hidden:any)
{
  if(hidden==="show")
  {
  this.Show_Reject_Reason_Input=true;
  this.Extend_Approval=false;
  console.log("show",this.Extend_Approval);

  }else if(hidden==="hide")
  {
  this.Show_Reject_Reason_Input=false;
  this.Extend_Approval=true;
  console.log("hide",this.Extend_Approval);

  }
}
onTextChange(event: Event): void {
  const newValue = (event.target as HTMLTextAreaElement).value;
     this.Extend_Reject_Reason=newValue;

  // Additional logic, if needed
}

  ExtensionApproval(ID:any,Approval:any,RejectReason:any){
    this.Extend_ID=ID;
    this.Extend_Approval=Approval;
    this.Extend_Reject_Reason=RejectReason;
    this.subscriptions.push(
      this._adminservices
        .Extension_Approval(
          ID,Approval,RejectReason
        )
        .subscribe(
          (ress) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Extension Approval has Submitted',
            });
            this.Extend_Reject_Reason=''
            // this.Extend_Approval=true;
            this.hideApproval();
            this.GetAllExtensionBookings();
          },
          (err: any) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${err.error.message}`,
            });
          }
        )
    );
  }
  GetAllExtensionBookings() {
    this.extensions=[]
   this.numberextension=0
console.log(this.searchText)
   this.subscriptions.push(this._adminservices.GetExtensionRequests( 1,20000,this.searchText).subscribe((res:any) => {
    this.extensions = res["data"];
    this.totalRecords=res["totalRecords"]

    this.numberextension = this.extensions.length;
    this.totalofPages=res["totalPages"]
    console.log(this.totalRecords+"-"+this.totalofPages);

    ///////////////
    const savedPage = localStorage.getItem('extenPage');
    this.currentPage = savedPage ? +savedPage : 0;
    console.log(this.currentPage) 
    this.tableReady = true;
    ////////////

   }, (error) => {
     console.error('Error fetching Extension:', error);
  }))

  }



  tiggerPageChange(event: any) {

    this.first = event.first;
    this.rows = event.rows;
    let calcPageNumber = Math.floor(this.first / this.rows) + 1;
    this.pageNumber = calcPageNumber;

       this.GetAllExtensionBookings()
      }
  Confirm_Approval(){

  }
  showDialog() {
    this.displayDialog = true;
  }
  OnReasonChange(event:any){
    const inputValue = (event.target as HTMLInputElement).value;
    this.Extend_Reject_Reason=inputValue;
  }
  confirmAction() {
    if (!this.Extend_Reject_Reason.trim()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Reason Required',
        detail: 'Please provide a reason for rejection.',
      });
      return;
    }
    this.messageService.add({
      severity: 'info',
      summary: 'Confirmed',
      detail: `Reason provided: ${this.Extend_Reject_Reason}`,
    });
    this.displayDialog = false;
  }

  addItem(value: any): void {
    this.showSide = value
  }


  //////////////////////////////////////////////
  

  customSort(event: { data: any[], field: string, order: number }) {
    event.data.sort((a, b) => {
      let valueA = a[event.field];
      let valueB = b[event.field];
  
      console.log("Before Sorting:", valueA, valueB); // Debugging output
  
      // ✅ Handle null values properly
      if (valueA == null && valueB == null) return 0;
      if (valueA == null) return event.order;  // Null values should appear last in ascending order
      if (valueB == null) return -event.order; // Null values should appear first in descending order
  
      // ✅ Convert string dates (like "Mar 5, 2025") into Date objects for sorting
      if (this.isValidDate(valueA) && this.isValidDate(valueB)) {
        let dateA = new Date(valueA);
        let dateB = new Date(valueB);
        let result = (dateA.getTime() - dateB.getTime()) * event.order;
  
        console.log("Sorted Dates:", dateA, dateB, "Result:", result); // Debugging output
  
        return result;
      }
  
  
        // ✅ التحقق مما إذا كانت القيم تواريخ
        if (this.isDate(valueA) && this.isDate(valueB)) {
          return (new Date(valueA).getTime() - new Date(valueB).getTime()) * event.order;
        }
  
  
      // ✅ Handle numeric sorting
      if (!isNaN(valueA) && !isNaN(valueB)) {
        return (parseFloat(valueA) - parseFloat(valueB)) * event.order;
      }
  
      // ✅ Handle text sorting (case insensitive)
      return valueA.toString().localeCompare(valueB.toString(), undefined, { numeric: true }) * event.order;
    });
  
    console.log("After Sorting:", event.data.map(item => item[event.field])); // Debugging output after sorting
  }
  
  
  
  
  // ✅ دالة تتحقق مما إذا كانت القيمة تاريخًا
  isDate(value: any): boolean {
    return !isNaN(Date.parse(value));
  }
   
  
  isValidDate(dateString: string): boolean {
    return dateString != null && !isNaN(Date.parse(dateString));
  }

   /////////////////////////////////////////////////////
   statuses = [
    { label: 'InReview', value: 'InReview' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Rejected', value: 'Rejected' }

  ];
  
  getSeverity(status: string): string {
    switch (status) {
      case 'Upcoming': return 'rounded-5 px-3 badge Upcoming';
      case 'Current': return 'rounded-5 px-3 badge Current';
      case 'Checked Out': return 'rounded-5 px-3 badge Cancelled';

      case 'Completed': return 'rounded-5 px-3 badge Completed';
      case 'Approved': return 'rounded-5 px-3 badge Approved';
      case 'Cancelled': return 'rounded-5 px-3 badge Cancelled';
      case 'InReview': return 'rounded-5 px-3 badge Pending';
      case 'Rejected': return 'rounded-5 px-3  badge Rejected';
      case 'CheckedOut': return 'rounded-5 px-3  badge Waiting';
      case 'Waiting': return 'rounded-5 px-3  badge Waiting';

      default: return '';
    }
  }
visible:boolean=false
  open(extend_ID:any) {
    this.visible = true;
    this.extend_ID=extend_ID
  }
selectedDate:any
  close() {
    this.visible = false;
    this.selectedDate = null;
  }
  extend_ID:any
    updateExtension() {

      if (!this.selectedDate || !this.extend_ID) return;
    
    
    // const utcDate = new Date(this.selectedDate).toISOString();
     const formattedDate = formatDate(this.selectedDate, 'yyyy-MM-dd', 'en-US');


    this._adminservices.changeExtensionDate(this.extend_ID, formattedDate).subscribe({
      next: (res) => {
        console.log('Date changed successfully:', res);
        this.close();
            this.messageService.add({
        severity: 'success',
        summary: 'changing date successfully',
        detail:  ` ${res.message|| 'Something went wrong. Please try again.'}`,
      });
    this.GetAllExtensionBookings()

      },
      error: (err) => {
        console.error('Error changing date:', err);
         this.messageService.add({
        severity: 'error',
        summary: 'changing date failed',
        detail:  ` ${err.error.message|| 'Something went wrong. Please try again.'}`,
      });
      }
    });
  }
}
